const restfulData = {
  links: [],
  tokens: [],
  root: '/api/users/isauth/'
}

export default {
  configureRestfulData: ({links, tokens}) => {
    restfulData.links = links
    if (tokens) {
      restfulData.tokens = tokens.reduce((i, acc) => ({...acc, ...i}))
    }
  },
  getLink: (rel, action) => {
    const link = restfulData.links.find(i => i.rel === rel && i.action === action)
    if (link) {
      return link.href
    }
    return false
  },
  getToken: name => restfulData.tokens[name],
  getRoot: () => restfulData.root
}
